import { useMemo } from "react";
import { filterVisiblePreservingSelected } from "@utils/chart-visibility-utils";

interface FocusOptionItem {
  datasetElementId: string;
  hidden?: boolean;
}

/**
 * Filters a Variable/Value Focus universe to visible items, while keeping a
 * saved-but-now-hidden selection in the list so it still renders as selected.
 */
export function useFocusOptionList<T extends FocusOptionItem>(
  items: T[],
  selectedId: string,
): { visibleItems: T[]; isSelectedHidden: boolean } {
  const visibleItems = useMemo(
    () =>
      filterVisiblePreservingSelected(
        items,
        (item) => item.datasetElementId === selectedId,
      ),
    [items, selectedId],
  );

  const isSelectedHidden = useMemo(
    () =>
      !!selectedId &&
      items.some((item) => item.datasetElementId === selectedId && item.hidden),
    [items, selectedId],
  );

  return { visibleItems, isSelectedHidden };
}
